// VueDatePicker is not currently registered globally — nothing in
// app/ imports <VueDatePicker />. This file exists as a stub so
// flipping the registration back on later is a small edit instead of
// re-creating the plugin from scratch.
//
// IMPORTANT: do not add `import VueDatePicker from '@vuepic/vue-datepicker'`
// at module scope here. The package's default-export interop fights
// with Vite's dep optimizer at runtime, throws
//   "does not provide an export named 'default'"
// in the browser, and crashes Nuxt's client bootstrap (which in turn
// stops every BFF $fetch — symptom: "frontend stopped loading data").
// When you do want to register VueDatePicker, import it INSIDE the
// plugin body so Vite handles it as a dynamic dep:
//
//   export default defineNuxtPlugin(async (nuxtApp) => {
//     const { default: VueDatePicker } = await import('@vuepic/vue-datepicker')
//     await import('@vuepic/vue-datepicker/dist/main.css')
//     nuxtApp.vueApp.component('VueDatePicker', VueDatePicker)
//   })
//
// Until then this is intentionally a no-op so Nuxt has a valid plugin
// default export (no build warning) and nothing throws on the client.
export default defineNuxtPlugin(() => {})
